const dictionary_fr = {
  select_lang: 'CHOOSE YOUR LANGUAGE:',
  lang: 'Français',
  locale: 'fr-FR',
  lang_short: 'fr',

  dateFormat: 'dd/MM/yyyy',
  datePlaceholder: 'DD/MM/YYYY',

  technical_error: 'A technical issue occurred. Please retry later.',
  technical_error_hard:
    'A technical issue occurred. Please contact the requester.<p style="color: #bbb; max-height: 200px">%s</p>',

  portal_link: 'https://paperfly.io/en',
  agb_link: 'https://paperfly.io/tos-en/',
  contact_link: 'https://paperfly.io/contact-en/',

  address_dialog_personalInfo: 'Informations personnelles',
  address_dialog_firstName: 'Prénom',
  address_dialog_lastName: 'Nom de famille',
  address_dialog_dateOfBirth: 'Date de naissance',
  address_dialog_dateOfBirth_err_18:
    "L'inscription est réservée aux personnes majeures.",
  address_dialog_contactInformation: 'Coordonnées',
  address_dialog_email: 'E-mail',
  address_dialog_phone: 'Téléphone',
  address_dialog_address: 'Adresse',
  address_dialog_street: 'Rue',
  address_dialog_houseNumber: 'N°',
  address_dialog_zipcode: 'Code postal',
  address_dialog_city: 'Ville',
  address_dialog_countryCode: 'Pays',

  dialog_atrust_settings_title: 'Signature qualifiée requise',
  dialog_atrust_select_next_options: 'Choisissez une option pour continuer',
  dialog_atrust_register_done:
    "L'identification vidéo est terminée, le processus de signature va démarrer.",
  dialog_atrust_register: "Démarrer l'identification WebID",
  dialog_atrust_register_help:
    'Créez une signature électronique qualifiée (QES) via A-Trust et WebID (identification vidéo).',
  dialog_atrust_login_exists: 'Se connecter avec un compte ID Austria existant',
  dialog_atrust_login_exists_help:
    'Vous avez déjà un compte ID Austria ? Connectez-vous avec vos identifiants existants.',
  dialog_atrust_error_on_registration:
    "Une erreur est survenue pendant l'identification vidéo. Veuillez réessayer.",
  dialog_atrust_cancelled_on_registration:
    "Identification vidéo annulée par l'utilisateur",
  dialog_atrust_unknown_error_on_registration:
    "Erreur inconnue lors de l'identification vidéo '%s'. Identification vidéo impossible",
  dialog_atrust_awaiting_registration:
    "En attente de l'identification vidéo...",
  dialog_atrust_already_registered:
    'Un utilisateur avec ces données possède déjà un compte. Se connecter au compte existant ?',
  dialog_atrust_login: 'Connexion',
  dialog_atrust_preparing_title: 'Préparation',
  dialog_atrust_preparing_help:
    "Veuillez patienter pendant la préparation du document pour l'identification vidéo.",
  dialog_atrust_preparing_help_login:
    'Veuillez patienter pendant la préparation du document pour la signature.',
  dialog_atrust_ready_to_sign_help:
    'Appuyez sur START pour terminer la signature dans la fenêtre A-Trust.',
  dialog_atrust_ready_for_webid_help:
    "Appuyez sur « Démarrer l'identification vidéo » pour continuer dans la fenêtre A-Trust.",
  dialog_atrust_awaiting_webid_help:
    "Veuillez terminer l'identification vidéo dans la fenêtre A-Trust.",
  dialog_atrust_awaiting_sign_help:
    'Veuillez terminer la signature dans la fenêtre A-Trust.',
  dialog_atrust_prep_document:
    'Préparation du document (création de la demande / finalisation)',
  dialog_atrust_prep_check_registration:
    "Vérification du statut d'identification vidéo",
  dialog_atrust_prep_document_error:
    'Impossible de préparer le document. Veuillez réessayer.',
  dialog_atrust_start_webid: "Démarrer l'identification vidéo",
  dialog_atrust_restart_webid: "Relancer l'identification vidéo",
  dialog_atrust_status_check_hint:
    "La vérification du statut peut prendre environ 5 secondes. Si la fenêtre A-Trust a été fermée pour une autre raison, recommencez l'identification vidéo.",
  dialog_atrust_status_check_help:
    "Vérification du statut d'identification vidéo…",
  dialog_atrust_confirm_restart_registration:
    "Interrompre la vérification du statut d'identification vidéo et recommencer l'identification vidéo ?",
  dialog_atrust_confirm_abort_status_check:
    "Interrompre la vérification du statut d'identification vidéo ?",
  dialog_atrust_registration_done_sign_hint:
    'Identification vidéo terminée avec succès. Appuyez sur START pour vous connecter et terminer la signature.',
  dialog_atrust_short_term_done_sign_hint:
    'Identification vidéo terminée avec succès. Vous disposez de 15 minutes pour terminer la signature dans la fenêtre A-Trust.',
  dialog_atrust_short_term_expired:
    "Le délai pour signer a expiré. Veuillez relancer l'identification vidéo.",
  dialog_atrust_document_sign: 'Signer le document',
  dialog_atrust_repeat_document_sign: 'Continuer la signature',
  dialog_atrust_sign_status_check_help: 'Vérification du statut de signature…',
  dialog_atrust_sign_status_check_hint:
    'La vérification du statut peut prendre environ 5 secondes. Si la fenêtre A-Trust a été fermée pour une autre raison, appuyez sur « Continuer la signature ».',
  dialog_atrust_complete_webid:
    "Terminer l'identification vidéo dans la fenêtre %s",
  dialog_atrust_prep_completed_sub: 'Demande · Document · Identification vidéo',
  qes_step_create_request: 'Création de la demande',
  qes_step_create_request_hint: 'Veuillez renseigner les données requises.',
  qes_ready_create_request_help:
    'Appuyez sur SUIVANT pour renseigner les données requises.',
  qes_step_prepare_document: 'Préparation du document',
  qes_step_check_registration: "Vérification du statut d'inscription",
  qes_step_check_signature: 'Vérification du statut de signature',
  qes_step_prep_completed: 'Préparation terminée',
  qes_step_prep_completed_sub: 'Demande · Document · Inscription',
  qes_step_complete_registration: "Terminer l'inscription dans la fenêtre %s",
  qes_step_complete_signing: 'Terminer la signature dans la fenêtre %s',
  qes_step_auto_close_hint: 'Fermeture automatique dans 3 s.',
  qes_registration_readonly_fields_hint:
    'Certains champs peuvent être en lecture seule car les données sont reprises directement des documents pour garantir une conformité totale. Si vous constatez une saisie incorrecte, veuillez revenir au document pour la corriger.',

  document_rejected_message: 'Ce document a été rejeté.',
  reject_document_title: 'Rejeter le document',
  reject_document_info:
    'Vous êtes sur le point de rejeter "%s". Veuillez indiquer une raison.',
  reject_document_reason: 'Motif du rejet',
  reject_document_reason_placeholder: 'Décrivez la raison du rejet...',
  reject_document_form_data: 'Données du formulaire',
  reject_document_dont_submit_data:
    'Ne pas transmettre les données du formulaire',
  reject_document_dont_submit_data_help:
    'Supprimer les données de formulaire existantes et ne pas les transmettre',
  reject_document_submit_data: 'Transmettre les données du formulaire',
  reject_document_submit_data_help:
    'Transmettre les données de formulaire existantes',

  home_password_wrong: 'Mot de passe incorrect',
  home_password_verification: 'Vérification...',
  home_password_required: 'Mot de passe requis',
  home_request_for_documents: '%s vous a demandé les documents suivants',
  home_request_for_payment: '%s vous a demandé un paiement',
  home_will_pay: 'Je souhaite payer',

  home_pay_with: 'avec mon ordinateur',
  home_now_pay: 'Payer maintenant',
  home_now_load: 'Soumettre les documents',
  home_now_load_one: 'Soumettre le document',
  home_now_view: 'Voir les documents',
  home_now_view_one: 'Voir le document',
  home_now_info: 'Lire',
  list_loaded_pages: 'Pages téléchargées',

  home_will_docs: 'Comment souhaitez-vous procéder ?',
  home_with_mobile_scan: 'Scannez le code QR pour passer sur votre téléphone',
  home_load_with: 'Continuer sur cet ordinateur',

  home_with_mobile: 'avec mon téléphone',
  home_webrtc_warning:
    "Pour pouvoir procéder à la vérification d'identité, vous devez ouvrir le lien dans Safari.",
  home_pincode_required: 'Veuillez saisir le code sécurisé.',
  home_pincode_failed: 'Le code que vous avez saisi est incorrect.',
  home_request_closed:
    'Cette demande a déjà été fermée. Veuillez contacter le demandeur.',
  home_request_notexists:
    "Cette demande n'existe pas. Veuillez contacter le demandeur.",
  home_qrcode_title: 'Scannez simplement le code QR avec votre téléphone',
  home_pin_required: 'Code sécurisé requis',
  home_deadline_title: 'Échéance : %s',
  home_security_info: 'Seul <b>%s</b> %s voir vos données.',
  home_security_info_part_may: 'peut',
  home_security_info_part_will: 'pourra',

  home_cookies_main:
    "Ce site web utilise des cookies pour améliorer le service, à des fins d'analyse et de publicité. En continuant à utiliser le service, vous acceptez notre utilisation des cookies comme décrit dans la Politique des Cookies.",
  home_cookie_accept: 'Accepter',
  home_cookie_necessary: 'Nécessaires',
  home_cookie_change: 'Paramètres',
  home_cookie_statistic: 'Statistiques',

  confirm_bio_data_collecting_title: 'Consentement',
  confirm_bio_data_collecting_message:
    "Dans le cadre de la signature électronique, votre vitesse d'écriture, la direction d'écriture, les pauses d'écriture et, le cas échéant, la pression d'écriture (données de catégorie spéciale) sont enregistrées et stockées sous forme cryptée. Ceci afin de prouver que vous avez écrit la signature. Si vous ne consentez pas au traitement de ces données, vous avez la possibilité de signer sur papier. Vous avez le droit de révoquer votre consentement à tout moment. La révocation du consentement n'affecte pas la légalité du traitement effectué sur la base de votre consentement jusqu'à la révocation.",
  confirm_bio_data_collecting_confirm: 'Consentir',

  user_credentials_title: 'Données nécessaires',

  complete_page_perform: 'Continuer',
  complete_page_title: 'Confirmation requise',
  complete_page_message:
    "Les données que vous avez saisies jusqu'à présent seront transmises à %s. Veuillez noter qu'une fois soumises, les données ne peuvent plus être modifiées.",

  qr_start_what_next: 'Comment voulez-vous procéder',
  qr_start_scan_btn: 'Commencer le scan',
  qr_start_request_btn: 'Démarrer la demande',
  qr_paste_url_placeholder: "Coller l'URL de la demande",
  qr_start_save_template: 'Sauvegarder le modèle',
  qr_start_start_template: 'Démarrer',
  qr_start_ignore_template: 'Ignorer et ne plus demander',
  qr_start_delete_template: 'Supprimer %s modèles ?',
  qr_start_delete_one_template: 'Supprimer le modèle',
  qr_start_template_not_found:
    'Ce modèle est introuvable et ne peut pas être démarré. Vous pouvez le supprimer de votre liste ou le conserver et réessayer plus tard.',
  qr_start_template_later: 'Plus tard',
  offline_template_unavailable:
    "Ce modèle n'est pas disponible hors ligne. Veuillez vous connecter à Internet et l'ouvrir une fois pour l'enregistrer pour une utilisation hors ligne.",
  offline_template_submit:
    'Une connexion Internet est requise pour soumettre cette demande. Veuillez vous connecter et réessayer.',
  pwa_update_title: 'Mise à jour disponible',
  pwa_update_applying: "Mise à jour de l'application…",
  pwa_update_message:
    "Une nouvelle version de l'application est disponible. Mettre à jour maintenant ? Les modifications non enregistrées seront perdues.",
  pwa_update_now: 'Mettre à jour',
  pwa_update_later: 'Plus tard',
  pwa_install_prompt_message:
    'Souhaitez-vous utiliser l’application Paperfly depuis votre écran d’accueil ?',
  pwa_install_prompt_link: 'Voir le guide d’installation',
  pwa_install_guide_popup_title: 'Installer l’application Paperfly',
  pwa_install_guide_intro:
    'Installez l’application sur votre écran d’accueil pour un accès plus rapide.',
  pwa_install_guide_ios_title: 'Installer sur iPhone ou iPad',
  pwa_install_guide_ios_step_1: 'Ouvrez cette page dans Safari.',
  pwa_install_guide_ios_step_2: 'Touchez le bouton Partager.',
  pwa_install_guide_ios_step_3:
    'Choisissez « Ajouter à l’écran d’accueil » et confirmez.',
  pwa_install_guide_android_title: 'Installer sur Android',
  pwa_install_guide_android_step_1: 'Ouvrez le menu du navigateur.',
  pwa_install_guide_android_step_2:
    'Touchez « Installer l’application » ou « Ajouter à l’écran d’accueil ».',
  pwa_install_guide_android_step_3: 'Confirmez l’installation.',
  pwa_install_guide_samsung_step_1: 'Ouvrez le menu du navigateur.',
  pwa_install_guide_samsung_step_2: 'Touchez « Ajouter à » ou « Installer ».',
  pwa_install_guide_samsung_step_3:
    'Choisissez « Écran d’accueil » et confirmez.',
  pwa_install_guide_firefox_android_step_1: 'Ouvrez le menu du navigateur.',
  pwa_install_guide_firefox_android_step_2:
    'Touchez « Installer » ou « Ajouter à l’écran d’accueil ».',
  pwa_install_guide_firefox_android_step_3: 'Confirmez l’installation.',
  pwa_install_guide_default_title: 'Installer depuis le navigateur',
  pwa_install_guide_default_step_1: 'Ouvrez le menu du navigateur.',
  pwa_install_guide_default_step_2:
    'Recherchez « Install app » / « Add to Home screen ».',
  pwa_install_guide_default_step_3: 'Confirmez et suivez les étapes.',

  qr_start_scan: 'Veuillez scanner un code QR Paperfly.',
  qr_start_message:
    "Pour utiliser un scanner de code QR, veuillez autoriser l'accès à votre webcam...",

  list_done: 'Terminé',
  list_send_docs: 'Soumettre les documents',
  list_request_processing: 'En cours',
  list_title_documents: 'Documents :',
  list_title_scan_documents: 'Veuillez soumettre les documents suivants :',
  list_title_got_documents: 'Vous avez reçu les documents suivants :',
  list_expired_warning_text:
    "L'échéance pour la soumission des documents a expiré. Veuillez contacter le demandeur.",
  list_success_message: 'Les documents ont été soumis avec succès %s.',
  document_success_message: 'Le document a été soumis avec succès %s.',
  list_success_message_at: ' à',
  list_item_scanned_document: 'Document scanné',
  list_item_scann_next: 'Scanner la suite',
  list_item_original_document: 'Document original',
  list_load_saved_documents:
    "<p>Il y a des données pour cette demande qui ont été mises en cache.</p> Voulez-vous restaurer l'état intermédiaire ?",
  list_load_saved_documents_yes: "Oui - continuer l'édition",
  list_load_saved_documents_no: 'Non - recommencer',

  standalone_draft_notification_title: 'Reprendre le processus',
  standalone_draft_notification_text:
    'Des données enregistrées existent pour le modèle "%s".',
  standalone_draft_restore:
    '<p>Des données mises en cache existent pour le modèle "%s".</p>Voulez-vous continuer l\'édition ?',
  standalone_draft_discard_other:
    'Des données enregistrées existent pour le modèle "%s". Si vous démarrez un nouveau modèle, les données précédemment enregistrées seront perdues.',
  standalone_draft_continue: 'Continuer',
  standalone_draft_saved_at: 'Dernière sauvegarde : %s',
  standalone_draft_new_start: 'Nouveau démarrage',
  standalone_draft_restart: 'Recommencer le processus',

  idcheck_summary: 'ID-Check - Résumé',
  idcheck_take_photo: "Capturer l'image",
  idcheck_start_camera: 'Démarrer la caméra',
  idcheck_page_selfie_step_title: 'Selfie',
  idcheck_page_title_selfie: "Photo d'autoportrait",
  idcheck_page_title_pass: "Carte d'identité",
  idcheck_scan_pass_item_title: "Scannez votre carte d'identité",
  idcheck_scan_pass_item_message_part1: 'Veuillez scanner votre ',
  idcheck_scan_pass_item_message_part2: ' ou ',
  idcheck_idcard: "carte d'identité",
  idcheck_pass: 'passeport',
  idcheck_doselfie_item_title: 'Votre photo',
  idcheck_doselfie_item_message:
    'Presque terminé, veuillez maintenant prendre un selfie.',
  idchek_document_front_side_step_title: 'Côté recto',
  idchek_document_front_side_title: 'Côté recto',
  idchek_document_front_side_desc_passport:
    'Veuillez télécharger une photo de votre passeport.',
  idchek_document_front_side_desc_identificationCard:
    "Veuillez télécharger une photo du recto de votre carte d'identité.",
  idchek_document_front_side_desc_driversLicense:
    'Veuillez télécharger une photo du recto de votre permis de conduire.',
  idchek_document_doc_photo_step_title: 'Photo du document',
  idchek_document_doc_photo_title:
    'Veuillez télécharger une photo de votre passeport.',
  idchek_document_doc_photo_desc:
    'Veuillez télécharger une photo de votre passeport.',
  idchek_document_back_side_step_title: 'Côté verso',
  idchek_document_back_side_title: 'Côté verso',
  idchek_document_back_side_desc_identificationCard:
    "Veuillez télécharger une photo du verso de votre carte d'identité.",
  idchek_document_back_side_desc_driversLicense:
    "Veuillez télécharger une photo du verso de votre carte d'identité.",
  idchek_document_live_photo_step_title: 'Photo en direct',
  idchek_document_live_photo_title: 'Photo en direct',
  idchek_document_live_photo_desc:
    'Veuillez tenir votre %s devant votre caméra pour que la réflexion des hologrammes du document soit visible.',
  idchek_document_select_doc_type_step_title: 'Type de document',
  idchek_document_select_doc_type_title:
    'Quel type de document voulez-vous utiliser ?',
  idchek_document_select_doc_type_desc:
    'Quel type de document voulez-vous utiliser ?',
  continue_on_mobile: 'Exécuter sur mobile',
  continue_on_mobile_title: 'Passer sur votre smartphone',
  idchek_do_on_desktop: 'Continuer sur cet ordinateur',
  continue_on_mobile_continue: 'Passer sur votre smartphone',
  continue_on_mobile_or_desktop: 'Comment souhaitez-vous procéder ?',
  continue_on_mobile_after_done:
    'Après avoir terminé sur votre smartphone, cliquez sur le bouton CONTINUER pour procéder.',
  id_check_doc_type_identificationCard: "Carte d'identité",
  id_check_doc_type_passport: 'Passeport',
  id_check_doc_type_driversLicense: 'Permis de conduire',
  idcheck_hold_phone_camera_information:
    'Veuillez tenir votre document devant votre caméra pour que la réflexion des hologrammes du document soit visible.',
  idcheck_hold_web_camera_information:
    "Veuillez tenir votre document devant la webcam de votre ordinateur, pour que la réflexion de l'hologramme du document soit visible (comme sur une photo d'exemple).",
  idcheck_load_photo_information:
    'Veuillez charger un scan ou une photo (avec une bonne résolution) de votre %s',

  cropper_is_to_small_message: "L'image est trop petite. Veuillez réessayer.",
  cropper_repeat: 'Nouveau',
  cropper_crop_on: 'Recadrer activé',
  cropper_crop_off: 'Recadrer désactivé',
  cropper_next: 'Suivant',

  action_rotate: 'Pivoter',
  action_replace: 'Remplacer',

  forms_fill_next: 'Continuer',
  forms_fill_later: 'Compléter plus tard',
  forms_cancel_changes: 'Annuler les modifications',
  forms_required: 'Ce champ est requis',
  forms_wrong_digit: 'Veuillez saisir un nombre valide',
  forms_wrong_email: 'Veuillez saisir un e-mail valide',
  forms_wrong_value: 'Veuillez saisir une valeur valide',
  forms_wrong_email_phone:
    'Veuillez saisir un e-mail ou un numéro de téléphone valide',
  forms_return_to_pdf: 'Retour à la vue PDF',
  forms_wrong_phone: 'Veuillez saisir un numéro de téléphone valide',
  forms_external_validation_error:
    "Une erreur s'est produite lors de la validation du formulaire. Vous ne pouvez pas terminer ce formulaire. Veuillez contacter l'expéditeur ou réessayer plus tard.",
  forms_external_validation_wait:
    "Veuillez patienter — vos saisies sont en cours de validation par l'expéditeur.",
  forms_external_validate: 'Valider',
  forms_pdf_as_quickform: 'Vue Formulaire rapide',

  documents_confirmed: 'Confirmé',

  filter_document: 'Document',
  filter_photo: 'Photo',
  filter_bwmode: 'Niveaux de gris',

  pdf_prev_page: 'Page précédente',
  pdf_next_page: 'Page suivante',
  pdf_form_hide_smartfill: "Masquer l'aide à la saisie",
  pdf_form_show_smartfill: "Démarrer l'aide à la saisie",
  pdf_smartfill_step: 'Étape :',
  pdf_return_from_smartfill:
    'Nous avons saisi vos entrées dans le document. Veuillez vérifier le document.',

  dialog_send_now: 'Envoyer les documents maintenant ?',
  dialog_delete_all: 'Supprimer toutes les pages ?',
  dialog_delete_page: 'Supprimer la page sélectionnée ?',
  dialog_delete_page_x: 'Supprimer la page %s ?',
  dialog_delete_pages: 'Supprimer les pages sélectionnées ?',
  dialog_load_all_required: 'Veuillez télécharger tous les documents requis.',
  dialog_attention: 'Attention',
  dialog_warning: 'Avertissement',
  dialog_processing: 'en cours...',
  dialog_fill_all_fields: 'Veuillez remplir tous les champs.',
  dialog_sending: 'Envoi en cours...',
  dialog_error_on_send:
    'Une erreur s\'est produite lors du téléchargement des documents.<br/><br/><div style="text-align: left; max-height: 70vh; overflow: auto;padding-left: 10px; font-size: 11px; color: #999">%s</div>',
  dialog_error_on_send_invalid_image:
    'Au moins une image téléchargée est endommagée ou dans un format non pris en charge. Veuillez revenir au(x) document(s) listé(s), télécharger ou photographier à nouveau l\'image, puis renvoyer la demande.<br/><br/><div style="text-align: left; max-height: 70vh; overflow: auto;padding-left: 10px; font-size: 11px; color: #999">%s</div>',
  sender_invalid_image_hint:
    'Image endommagée ou non prise en charge. Veuillez la télécharger ou la photographier à nouveau.',
  dialog_fill_all_required: 'Veuillez remplir tous les champs requis.',
  dialog_changies_will_removed:
    'Toutes les modifications seront annulées. \n' +
    'Voulez-vous vraiment continuer ?',
  dialog_continue: 'Procéder',

  dialog_required_document_IMMEDIATE_CONFIRMATION: 'Veuillez confirmer "%s".',
  dialog_required_document_ID_CHECK:
    "Veuillez effectuer la vérification d'identité.",
  dialog_required_document_FORM: 'Veuillez remplir "%s"',
  dialog_required_document_FORM_PDF: 'Veuillez remplir "%s".',
  dialog_required_document_DOCUMENT:
    'Veuillez télécharger ou prendre une photo de "%s".',
  dialog_required_document_PAYMENT: 'Veuillez effectuer le paiement.',
  dialog_required_document_INFORMATION: 'Veuillez lire le document "%s".',

  footer_imprint: 'Mentions légales',
  footer_conditions: 'Avis de confidentialité et CGU',
  footer_privacy: 'Confidentialité',
  footer_support: 'Support',

  thankyou_is_done: 'Merci, vous avez terminé !',
  thankyou_receive_your_documents: '%s a maintenant reçu vos documents.',
  thankyou_you_may_close: 'Vous pouvez maintenant fermer cet onglet.',

  info_popup_docs_from: 'Vous avez reçu cette demande de <b>%s</b>. ',
  info_popup_message_part1: 'Ce service est alimenté par ',
  info_popup_message_part2:
    '. Avec Paperfly, vous pouvez collecter des données, des documents, des signatures électroniques et des paiements. Si vous voulez en savoir plus sur Paperfly, jetez un œil à cette courte ',
  info_popup_message_part3: ' .',
  info_popup_emailto_sender_1: 'Vous pouvez contacter %s à ',
  info_popup_emailto_sender_2: '.',

  upload_load_next_page: 'Veuillez télécharger %s pages supplémentaires',
  upload_all_done: 'Toutes les pages sont terminées',
  upload_delete_page: 'Supprimer la page',
  upload_camera: 'Prendre une photo',
  upload_disk: 'Télécharger',
  upload_file: 'Choisir un fichier',

  sort_next_x_pages: '%s pages supplémentaires',
  sort_new_page: 'Nouvelle page',
  sort_next_x_pages_photo: '%s photos supplémentaires',
  sort_new_page_photo: 'Nouvelle photo',
  sort_prepare_page_x: 'Veuillez préparer la page %s',
  gallery_select_pages: 'Sélectionner les pages',
  gallery_x_from_y_selected: '%s sur %s sélectionnées',

  payment_creditcard: 'Carte de crédit',
  payment_sepa: 'SEPA',
  payment_wallet: 'Portefeuille',
  payment_error_message:
    "Une erreur s'est produite lors du traitement du paiement",
  payment_error_title: 'Échec du paiement',
  payment_do_pay: 'Payer',
  payment_pay: 'Payer',
  payment_sepa_information:
    'Vous avez accepté le mandat de prélèvement automatique. Le montant %s sera débité de votre compte bancaire.',
  payment_paid: 'Payé',
  payment_summ: 'Montant',
  payment_change_payment_method: 'Changer le mode de paiement',
  payment_select_payment_method: 'Veuillez choisir un mode de paiement',
  payment_pay_x: 'Payer %s',
  payment_iban: 'IBAN',
  payment_sepa_long_information:
    "En acceptant le mandat de prélèvement automatique SEPA, vous autorisez Paperfly et Stripe à collecter les paiements de votre compte bancaire par prélèvement automatique. En même temps, vous instruisez votre banque de rembourser les prélèvements automatiques émis par Paperfly et Stripe. Note : Vous pouvez demander un remboursement du montant débité dans les huit semaines, à partir de la date de débit. Les conditions convenues avec votre banque s'appliquent.",
  payment_confirm_sepa: 'Confirmer le mandat de prélèvement automatique',
  payment_wallet_not_available: 'Actuellement indisponible',

  viewer_download_required_title: 'Veuillez télécharger le document',
  viewer_download_required_message:
    "Pour lire le document, vous devez d'abord le télécharger.",

  forms_sign: 'Signer',
  forms_sign_with_yes: 'Signer avec yes®',
  forms_sign_with_atrust: 'Signer avec Atrust',
  forms_sign_please: 'Veuillez signer',

  camera_disabled_title: 'Paperfly souhaite accéder à la caméra',
  camera_disabled_message:
    "L'accès à la caméra a été bloqué. Sans cette autorisation, la caméra ne peut pas être utilisée.",
  camera_disabled_help_chrome:
    "Pour réautoriser la caméra : cliquez sur l'icône cadenas ou caméra à gauche de la barre d'adresse → réglez Caméra sur « Autoriser » → rechargez la page et réessayez.",
  camera_disabled_help_safari_ios:
    "Pour réautoriser la caméra : dans Safari, touchez « aA » à gauche de la barre d'adresse → Réglages du site web → réglez Caméra sur « Autoriser » → revenez à l'application et réessayez.",
  camera_disabled_help_safari:
    'Pour réautoriser la caméra : menu Safari → Réglages pour ce site web → réglez Caméra sur « Autoriser » → rechargez la page et réessayez.',
  camera_disabled_help_firefox:
    "Pour réautoriser la caméra : cliquez sur l'icône des permissions à gauche de la barre d'adresse → autorisez la caméra → rechargez la page et réessayez.",
  camera_disabled_help_generic:
    'Ouvrez les paramètres du site dans votre navigateur, autorisez la caméra pour cette page, puis réessayez.',
  camera_permission_preprompt:
    'Votre navigateur va demander l’accès à la caméra. Veuillez choisir « Autoriser ».',
  camera_permission_continue: 'Démarrer la caméra',
  camera_permission_retry: 'Réessayer',
  camera_starting_message: 'Démarrage de la caméra…',
  camera_error_message: "Aucune caméra n'a été trouvée",
  camera_error_message2: 'La caméra ne fonctionne pas',

  common_error: 'Erreur',
  common_page: 'Page ',
  common_page_x: 'Page %s',
  common_all: 'Tout',
  common_page_x_from_y: 'Page %s / %s',
  common_page_x_from_y_2: 'Page %s sur %s',
  common_yes: 'Oui',
  common_name: 'Nom',
  common_email: 'E-mail',
  common_count_selected: '%s sélectionné(s)',

  sender_cant_send_request: "L'action ne peut pas être effectuée",
  //qes
  dialog_edit_will_off_after_qes_title: 'Avez-vous complété tous les champs ?',
  dialog_edit_will_off_after_qes:
    'Veuillez vérifier que tous les champs requis ont été remplis. Une fois le document signé, aucune modification ne pourra être apportée.',
  esign_sign_type_not_supported: 'Signature qualifiée de "%s" non supportée',

  //signme
  signme_now_document_sign: 'Signer le document de manière qualifiée',
  signme_settings_registration_info:
    '<b>sign-me</b> est un service de D-Trust GmbH. Nous travaillons avec D-Trust pour vous offrir des <b>signatures qualifiées</b>.',
  dialog_signme_settings_title: 'Se connecter à sign-me',
  dialog_signme_preparing_title: 'Préparation',
  dialog_signme_preparing_help:
    "Veuillez patienter pendant la préparation du document pour l'inscription sign-me.",
  dialog_signme_preparing_help_login:
    'Veuillez patienter pendant la préparation du document pour la signature.',
  dialog_signme_ready_to_register_help:
    "Appuyez sur « Configurer » pour poursuivre l'inscription dans la fenêtre sign-me.",
  dialog_signme_ready_to_sign_help:
    'Appuyez sur START pour terminer la signature dans la fenêtre sign-me.',
  dialog_signme_registration_done_sign_hint:
    'Inscription terminée avec succès. Appuyez sur START pour signer avec le compte que vous venez de créer.',
  dialog_signme_awaiting_register_help:
    "Veuillez terminer l'inscription dans la fenêtre sign-me.",
  dialog_signme_awaiting_sign_help:
    'Veuillez terminer la signature dans la fenêtre sign-me.',
  dialog_signme_restart_signing: 'Relancer la signature',
  dialog_signme_status_check_hint:
    'La vérification du statut peut prendre environ 5 secondes. Si la fenêtre sign-me a été fermée pour une autre raison, relancez la signature.',
  dialog_signme_status_check_help: 'Vérification du statut de signature…',
  dialog_signme_confirm_restart_signing:
    'Interrompre la vérification du statut de signature et relancer la signature ?',
  dialog_signme_confirm_abort_status_check:
    'Interrompre la vérification du statut de signature ?',
  signme_settings_registration_form_title:
    "Vos données selon votre pièce d'identité",
  signme_settings_label_mobilePhoneNumber:
    'Numéro de mobile (ex. +33 123456789)',
  INVALID_PHONE_NUMBER_SIGNME: 'Numéro de mobile invalide.',
  signme_settings_label_mobilePhoneNumber_info:
    "Séparation de l'indicatif du reste du numéro de mobile par un espace réussie",
  signme_settings_label_emailAddress: 'E-mail',
  signme_settings_label_givenNames: 'Prénom',
  signme_settings_label_familyName: 'Nom de famille',
  signme_settings_processing_data: 'Traitement',
  signme_settings_registration_done: 'sign-me connecté avec succès',
  signme_settings_registration_failed:
    "Une erreur s'est produite lors de la tentative de connexion à sign-me. Veuillez réessayer plus tard.",
  signme_settings_nopopup_message:
    'Les dialogues pop-up doivent être activés pour se connecter à sign-me',
  yes_settings_nopopup_message:
    'Les dialogues pop-up doivent être activés pour se connecter à yes®',
  atrust_settings_nopopup_message:
    'Les dialogues pop-up doivent être activés pour se connecter à Atrust',
  signme_settings_nopopup_title: 'Vérifiez les paramètres de votre navigateur',
  popup_blocked_help_chrome:
    '<b>Autoriser les pop-ups dans Google Chrome</b><br/><br/><b>Recommandé (sans rechargement) :</b><br/>• Regardez la barre d’adresse — une icône de pop-up bloquée y apparaît souvent (fenêtre barrée).<br/>• Cliquez dessus et autorisez les pop-ups pour ce site.<br/>• Appuyez ensuite à nouveau sur Démarrer — ne rechargez pas la page, sinon les données saisies peuvent être perdues.<br/><br/><b>Si aucune icône n’est visible :</b><br/>• Cliquez sur le menu à trois points en haut à droite → Paramètres.<br/>• Confidentialité et sécurité → Paramètres des sites → Fenêtres pop-up et redirections.<br/>• Autorisez les pop-ups pour ce site (exception personnalisée).<br/>• Revenez à Paperfly et appuyez à nouveau sur Démarrer — ne rechargez qu’en dernier recours.',
  popup_blocked_help_edge:
    '<b>Autoriser les pop-ups dans Microsoft Edge</b><br/><br/><b>Recommandé (sans rechargement) :</b><br/>• Regardez la barre d’adresse — une icône de pop-up bloquée y apparaît souvent (fenêtre barrée).<br/>• Cliquez dessus et autorisez les pop-ups pour ce site.<br/>• Appuyez ensuite à nouveau sur Démarrer — ne rechargez pas la page, sinon les données saisies peuvent être perdues.<br/><br/><b>Si aucune icône n’est visible :</b><br/>• Cliquez sur le menu à trois points en haut à droite → Paramètres.<br/>• Cookies et autorisations de site → Fenêtres pop-up et redirections.<br/>• Autorisez les pop-ups pour ce site.<br/>• Revenez à Paperfly et appuyez à nouveau sur Démarrer — ne rechargez qu’en dernier recours.',
  popup_blocked_help_safari_ios:
    '<b>Autoriser les pop-ups dans Safari sur iPhone ou iPad</b><br/><br/><b>Recommandé (sans rechargement) :</b><br/>• Vérifiez la barre d’adresse ou le message « Pop-up bloqué » et autorisez la pop-up si proposé.<br/>• Appuyez ensuite à nouveau sur Démarrer — ne rechargez pas la page, sinon les données saisies peuvent être perdues.<br/><br/><b>Si ce n’est pas possible :</b><br/>• Ouvrez l’app Réglages → Safari.<br/>• Désactivez Bloquer les pop-up.<br/>• Revenez à Paperfly et appuyez à nouveau sur Démarrer — ne rechargez qu’en dernier recours.',
  popup_blocked_help_safari:
    '<b>Autoriser les pop-ups dans Safari</b><br/><br/><b>Recommandé (sans rechargement) :</b><br/>• Regardez la barre d’adresse — un message ou une icône de pop-up bloquée y apparaît souvent.<br/>• Autorisez les pop-ups pour ce site.<br/>• Appuyez ensuite à nouveau sur Démarrer — ne rechargez pas la page, sinon les données saisies peuvent être perdues.<br/><br/><b>Si aucun message n’est visible :</b><br/>• Menu Safari → Réglages (ou Préférences…) → Sites web → Fenêtres pop-up.<br/>• Réglez ce site sur Autoriser.<br/>• Revenez à Paperfly et appuyez à nouveau sur Démarrer — ne rechargez qu’en dernier recours.',
  popup_blocked_help_firefox:
    '<b>Autoriser les pop-ups dans Mozilla Firefox</b><br/><br/><b>Recommandé (sans rechargement) :</b><br/>• Regardez la barre d’adresse ou la barre d’info — un message de pop-up bloquée y apparaît souvent.<br/>• Cliquez dessus et autorisez les pop-ups pour ce site.<br/>• Appuyez ensuite à nouveau sur Démarrer — ne rechargez pas la page, sinon les données saisies peuvent être perdues.<br/><br/><b>Si aucun message n’est visible :</b><br/>• Menu → Paramètres → Vie privée et sécurité → Permissions.<br/>• À côté de Bloquer les fenêtres popup → Exceptions… et autorisez ce site.<br/>• Revenez à Paperfly et appuyez à nouveau sur Démarrer — ne rechargez qu’en dernier recours.',
  popup_blocked_help_generic:
    '<b>Autoriser les pop-ups dans votre navigateur</b><br/><br/><b>Recommandé (sans rechargement) :</b><br/>• Regardez la barre d’adresse — une icône de pop-up bloquée y apparaît souvent (fenêtre barrée).<br/>• Cliquez dessus et autorisez les pop-ups pour ce site.<br/>• Appuyez ensuite à nouveau sur Démarrer — ne rechargez pas la page, sinon les données saisies peuvent être perdues.<br/><br/><b>Si aucune icône n’est visible :</b><br/>• Ouvrez les paramètres du navigateur et recherchez Pop-ups.<br/>• Autorisez les pop-ups pour ce site.<br/>• Revenez à Paperfly et appuyez à nouveau sur Démarrer — ne rechargez qu’en dernier recours.',
  signme_settings_label_name: 'Utilisateur',

  signme_settings_label_status: 'Statut',
  signme_settings_label_created: 'Créé le',
  signme_settings_label_dateOfBirth: 'Date de naissance',
  signme_settings_label_placeOfBirth: 'Lieu de naissance',
  signme_settings_label_placeOfResidence_street: 'Rue',
  signme_settings_label_placeOfResidence_city: 'Ville',
  signme_settings_label_placeOfResidence_zipCode: 'Code postal',
  signme_settings_label_placeOfResidence_country: 'Pays',

  esignature_sign_document_error_message:
    "La création de signature pour ce document n'a pas pu être terminée",
  esignature_sign_document_error_title:
    'Erreur lors de la création de la signature',
  esignature_document_signed: 'Document signé avec succès',

  error_field_is_required: 'Ce champ est requis.',
  INVALID_EMAIL: 'E-mail invalide',
  signme_settings_label_register: 'Configurer',

  request_stepper_check_and_send:
    "Veuillez vérifier vos entrées avant d'envoyer.",

  title_add: 'Ajouter',
  title_attention: 'Information',
  title_show_more: 'Afficher plus',
  title_edit: 'Modifier',
  title_check: 'Terminé',
  title_yes: 'Oui',
  title_no: 'Non',
  title_ok: 'Ok',
  title_sendout: 'Envoyer',
  title_will_prepared: ' est en cours de traitement...',
  title_preparing: 'Préparation',
  title_load: 'Chargement',
  title_fill: 'Remplir',
  title_change: 'Modifier',
  title_execute: 'Exécuter',
  title_read: 'Lire',
  title_read_and_accept: 'Lire et confirmer',
  title_had_read: 'Aller à la dernière page',
  title_see: 'Voir',
  title_do_select: 'Choisir',
  title_confirmation: 'Confirmation',
  title_confirm: 'Confirmer',
  title_unconfirm: 'Révoquer la confirmation',
  title_unconfirm_short: 'Révoquer',
  title_delete: 'Supprimer',
  title_successfull: 'Réussi',
  title_successfull_sent: 'Envoyé avec succès',
  title_cancel: 'Annuler',
  title_select: 'Choisir',
  title_dropdown_select: 'Sélectionner...',
  title_done: 'Terminé',
  title_summary: 'Résumé',
  title_close: 'Fermer',
  title_reject: 'Rejeter',
  title_reject_and_send: 'Rejeter et terminer',
  title_information: 'Information',
  title_or: 'ou',
  title_back: 'Retour',
  title_prev: 'Précédent',
  title_next: 'Suivant',
  title_continue: 'Continuer',
  title_start: 'Démarrer',
  title_fillin: 'Remplir',
  title_read_next: 'Continuer la lecture',
  title_save: 'Sauvegarder',
  title_personal_message: "Message de l'expéditeur :",
  title_documents_request: 'Demande',
  title_loading: 'Chargement',
  title_download: 'Télécharger',
  title_print: 'Imprimer',
  title_print_and_sign: 'Imprimer et signer',
  title_camera: 'Caméra',
  title_upload_signature: 'Télécharger la signature',
  title_sign_on_mobile: 'Signer sur smartphone',
  title_sign_on_screen: "Signer à l'écran",
  title_please_choose: 'Veuillez choisir',
  title_done_request: 'Terminer la demande ?',
  title_done_request_confirm: 'Voulez-vous vraiment terminer cette demande ?',
  title_done_request_rest_signatures:
    'Les champs de signature suivants sont encore ouverts :',
  title_done_request_with_sign_confirm:
    'Il y a des champs de signature supplémentaires disponibles. Êtes-vous sûr de vouloir terminer cette demande ?',
  title_step: 'Étape',
  title_apply: 'Appliquer',
  title_today: "Aujourd'hui",

  title_use_last_signature: 'Utiliser la dernière signature',
  sign_on_mobile_info: 'Scannez ce code QR avec votre téléphone',
  sign_on_mobile_set_failed:
    "Une erreur s'est produite lors de l'envoi de la signature. Veuillez réessayer plus tard.",

  post_request_save_email_message:
    'Souhaitez-vous recevoir une copie des données par e-mail ou SMS ?',
  post_request_save_email_only_message:
    'Souhaitez-vous recevoir une copie des données par e-mail ?',
  post_request_save_email_success:
    'Vous recevrez bientôt %s avec un lien de téléchargement.',
  post_request_your_email: 'Votre e-mail',
  post_request_your_email_message:
    'Veuillez saisir votre e-mail ou numéro de téléphone',
  post_request_your_phone_only_message:
    'Veuillez saisir votre numéro de téléphone',
  post_request_your_email_only_message: 'Veuillez saisir votre e-mail',
  post_request_wrong_email_phone:
    'Veuillez saisir un e-mail ou numéro de téléphone valide',
  post_request_wrong_phone_only:
    'Veuillez saisir un numéro de téléphone valide',
  post_request_wrong_email_only: 'Veuillez saisir un e-mail valide',
  post_request_email: 'E-Mail',
  post_request_sms: 'SMS',

  create_case_message_1: 'Vous avez presque terminé !',
  create_case_message_2:
    'Veuillez saisir votre nom et votre e-mail ou numéro de téléphone.',
  create_case_your_data: 'Vos données :',
  create_case_recipient: 'Destinataire %s ',
  create_case_recipient_data: 'Données de %s :',
  create_case_your_name: 'Votre nom',
  create_case_your_firstName: 'Votre prénom',
  create_case_your_lastName: 'Votre nom de famille',
  create_case_recipient_name: 'Nom du destinataire %s',
  create_case_name: 'Nom',
  create_case_role_name: 'Nom de %s',
  create_case_role_email: 'E-mail de %s',
  create_case_role_phone: 'Numéro de téléphone de %s',
  create_case_role_email_phone: 'E-mail ou numéro de téléphone de %s',
  create_case_email_phone: 'E-mail ou numéro de téléphone',
  create_case_your_email_phone: 'Votre e-mail ou numéro de téléphone',
  create_case_phone: 'Votre numéro de téléphone',
  create_case_recipient_email_phone:
    'E-mail ou numéro de téléphone du destinataire %s',
  create_case_recipient_phone: 'Numéro de téléphone du destinataire %s',
  create_case_rights_text:
    'J\'ai pris connaissance de la <a class="link external" href="https://paperfly.io/privacy/" target="_blank">politique de confidentialité</a>. J\'accepte le stockage et le traitement électroniques de mes données saisies.' +
    "<p><i>Note : Le consentement peut être révoqué à tout moment pour l'avenir par e-mail à %s.</i></p>",
  recent_templates: 'Modèles sauvegardés',

  qr_direkt_request_or: 'ou',
  qr_direkt_request_message: "Veuillez saisir l'URL de la demande directement",
  qr_add_new_template: 'Ajouter un nouveau modèle',
  qr_new_template: 'Nouveau modèle',

  restart_app_title: 'Nouvelle version disponible',
  restart_app_message:
    "Nous avons publié une nouvelle version de l'application. Pour continuer, l'application doit être redémarrée une fois – sans redémarrage, il n'est malheureusement pas possible de poursuivre. Merci de votre compréhension.",
  restart_app_message_data_saved:
    "Nous avons publié une nouvelle version de l'application. Pour continuer, l'application doit être redémarrée une fois – sans redémarrage, il n'est malheureusement pas possible de poursuivre. Vos saisies ont été sauvegardées et seront restaurées automatiquement après le redémarrage.",
  restart_app_yes: 'Redémarrer',
  restart_app_message_data_lost:
    "Nous avons publié une nouvelle version de l'application. Pour continuer, l'application doit être redémarrée une fois – sans redémarrage, il n'est malheureusement pas possible de poursuivre. Malheureusement, nous n'avons pas pu sauvegarder vos saisies, veuillez les saisir à nouveau après le redémarrage. Nous vous prions de nous excuser.",
  restart_app_failed_title: "Impossible de charger l'application",
  restart_app_failed_message:
    "L'application n'a pas pu être chargée. Veuillez réessayer plus tard ou ouvrir le lien dans un autre navigateur.",
  restart_app_data_restored:
    'Vos saisies ont été restaurées après la mise à jour. Vous pouvez continuer.',
  chunk_load_network_title: 'Problème de connexion',
  chunk_load_network_message:
    "Une partie de l'application n'a pas pu être chargée. Veuillez vérifier votre connexion Internet.",
  chunk_load_retry: 'Réessayer',

  merkur_message_1:
    'Pouvons-nous vous contacter par e-mail ou SMS pour de futures confirmations ?',
  merkur_message_2:
    "Cela rend non seulement vos opérations bancaires beaucoup plus simples, mais contribue également activement à la protection de l'environnement et du climat. Si vous êtes d'accord, complétez simplement les informations suivantes.",

  merkur_sendout_agree: 'Oui, je souhaite être contacté par e-mail ou SMS.',

  dialog_aes_popup_title: 'Confirmez votre identité',
  dialog_opt_popup_title: 'Authentification à deux facteurs',
  aes_popup_docs_title:
    'Les documents suivants doivent être signés avec une signature avancée',
  aes_popup_sign: 'SIGNER',
  aes_popup_label_agb:
    "Je confirme par la présente que mon prénom et nom, l'e-mail et le numéro de téléphone mobile sont corrects",
  aes_popup__info: 'Votre signature inclura les données suivantes : ',
  opt_enter_code:
    'Veuillez saisir le code SMS que nous avons envoyé à votre téléphone mobile ',
  opt_verify: 'Vérifier le code',
  aes_popup_if_data_wrong_absender: " l'expéditeur",
  aes_popup_label_name: 'Nom',
  aes_popup_label_emailAddress: 'E-mail',
  aes_popup_label_phone: 'Téléphone mobile',
  aes_popup_if_data_wrong:
    'Si vos données sont incorrectes, veuillez contacter ',
  opt_popup_error:
    "Une erreur technique s'est produite. Veuillez réessayer plus tard",
  opt_get_code: 'Demander le code de vérification',
  opt_code_success: 'Vous vous êtes authentifié avec succès',

  app_send_err: 'Send error:',
  app_err_desc: 'Description (optional)',
  app_fatal_err: "Nous sommes désolés, mais une erreur interne s'est produite.",
  app_restart_app: "Redémarrer l'application",
  app_err_send: 'Send'
};

export default dictionary_fr;
